var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4","order-md":"last"}},[_c('question-number-list')],1),_c('v-col',{attrs:{"cols":"12","md":"8","order-md":"first"}},[_c('question-box')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }